import request from '@/utils/request'


// 查询用户支付绑定列表
export function listPaymentBind(query) {
  return request({
    url: '/user/payment/bind/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户支付绑定分页
export function pagePaymentBind(query) {
  return request({
    url: '/user/payment/bind/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户支付绑定详细
export function getPaymentBind(data) {
  return request({
    url: '/user/payment/bind/detail',
    method: 'get',
    params: data
  })
}

// 新增用户支付绑定
export function addPaymentBind(data) {
  return request({
    url: '/user/payment/bind/add',
    method: 'post',
    data: data
  })
}

// 修改用户支付绑定
export function updatePaymentBind(data) {
  return request({
    url: '/user/payment/bind/edit',
    method: 'post',
    data: data
  })
}

// 删除用户支付绑定
export function delPaymentBind(data) {
  return request({
    url: '/user/payment/bind/delete',
    method: 'post',
    data: data
  })
}

// 审核用户支付绑定
export function auditPaymentBind(data) {
  return request({
    url: '/user/payment/bind/audit',
    method: 'post',
    data: data
  })
}
